<template>
  <div>
    <Header title="授课数据申请审核"></Header>
    <div class="sjqrshClass">
      <div class="chooseList">
        <van-search v-model="value" placeholder="搜索" />
        <NOdata
          v-if="this.newList && this.newList.length == 0"
          title="未查询到授课数据申请审核"
        ></NOdata>
        <div v-else class="list">
          <div
            class="list-item info"
            v-for="(item, index) in newList"
            :key="index"
            @click="goDtail(item)"
          >
            <p>{{ item.KCMC }}({{ item.KCH }})</p>
            <ul>
              <li>通知单号：{{ item.JX0404ID }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tApi from "../../../../utils/teacher";

export default {
  data() {
    return {
      list: [],
      value: ""
    };
  },
  methods: {
    goDtail(item) {
      item.route = "/sksjsqsh/index";
      this.$router.push({
        path: "/sksjsqsh/detail",
        query: {
          list: item
        }
      });
    },
    async getList() {
      const res = await tApi.getSksjsq();
      this.list = res.data;
    }
  },
  computed: {
    newList: function() {
      var value = this.value;
      if (value) {
        return this.list.filter(function(product) {
          return Object.keys(product).some(function(key) {
            return (
              String(product[key])
                .toLowerCase()
                .indexOf(value) > -1
            );
          });
        });
      }
      return this.list;
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less">
.sjqrshClass {
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  .chooseList {
    padding: 5% 5% 0;
    .van-search {
      padding: 0;
      height: 44px;
      background: #f4f5ff;
      border-radius: 3px;
      margin-bottom: 5%;
    }
    .van-search .van-cell,
    .van-search__content,
    .van-field__control {
      background: #f4f5ff;
    }

    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }

    .list-head {
      height: 80px;
      background-image: url("../../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding: 6% 7%;
      box-sizing: border-box;
      margin-bottom: 5%;

      div {
        width: 50%;
        height: 100%;
        p {
          font-size: 12px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        span {
          display: flex;
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 70%;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
    .list {
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin: 0 auto 5%;
        padding: 3% 0 3% 6%;
        position: relative;
        p {
          width: 70%;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          margin-bottom: 2%;
        }
        ul li {
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
      }
    }
  }
  .info {
    span {
      width: 70px;
      height: 42px;
      border-radius: 5px;
      position: absolute;
      top: calc(50% - 25px);
      right: 5%;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 15px;
      i {
        font-style: normal;
        font-family: PingFangSC-Light;
        font-size: 10px;
        color: #7469f8;
        letter-spacing: 0;
        font-weight: lighter;
      }
    }
  }
  .update span {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    letter-spacing: 0;
    text-align: right;
    border-top: 1px solid #dee1e9;
    display: block;
    text-align: center;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .bmClass {
    background-color: #7469f8;
    color: #fff;
  }
  .qxxkClass {
    background-color: #ecedfd !important;
    color: #7469f8;
  }
  .ybmClass {
    background-color: transparent !important;
    color: #7469f8;
    font-weight: bold !important;
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/sksjsqsh/index.vue